import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { get } from 'lodash';

import { updateEvent as updateEventInStore } from '../../store/actions/events';
import { getSelfieCamConfig } from '../../helpers/api';
import { displayErrorModal } from '../../helpers/swal';

/** Ai Template pages: load one selfieCam payload (`getSelfieCamConfig` → store + `config`). */
// eslint-disable-next-line import/prefer-default-export
export const useSelfieCamConfig = (slugDate) => {
  const dispatch = useDispatch();
  const [config, setConfig] = useState(null);
  const [event, setEvent] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!slugDate) {
      setConfig(null);
      setIsLoading(false);
      return () => {};
    }

    let cancelled = false;
    setIsLoading(true);
    setConfig(null);

    getSelfieCamConfig(slugDate)
      .then((data) => {
        if (cancelled) return;
        dispatch(updateEventInStore(data));
        setEvent(get(data, 'event'));
        setConfig(get(data, 'event.selfiecam'));
      })
      .catch((err) => {
        if (!cancelled) {
          console.error(err);
          displayErrorModal({ text: 'Failed to load config.' });
        }
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => { cancelled = true; };
  }, [slugDate, dispatch]);

  return { event, config, isLoading };
};
